import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import {encrypt} from "./../../../../helpers/CryptoJs"
import iconPath from "./../../../../helpers/iconHelper";
import $ from "jquery";
import CreateAlbum from "../../../AlbumContainer/CreateAlbum";
import { getlanguagelist } from "./../../../../helpers/changelanguage";
import "./UserAlbum.css";

function iconStyles() {
  return {
    successIcon: {
      color: 'green',
    },
    errorIcon: {
      color: 'red',
    },
  }
}


const useStyles = makeStyles(theme => ({
  root: {
   
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: (screen.width - 120),
    height: 1000,
  },
  
  icon: {
    color: 'rgba(255, 255, 259, 0.54)',
  },
}));

const handleScroll = (props) =>{
  if ($(window).scrollTop() + $(window).height()  ==  $(document).height()) {
      if(props.totalAlbumPage > props.albumPagination){
        //console.log('call next page');
        
      }
    }
}


const toggleFunction = (id) => {
    $('#togglediv'+id).toggle();
}

export default function UserAlbum(props) {


  window.addEventListener('scroll', handleScroll(props), true);
  const iconclasses = makeStyles(iconStyles)();
  const classes = useStyles();
  const {albumList,totalAlbum,albumPagination} = props.galleryDetails;
  const sectionheight = `${(Math.ceil(totalAlbum/2)) * 200}px`;

  const deleteAlbum = (albumid,feedis,type) => {
    props.deleteUserFeed(albumid,feedis,type);
  }

  let  languagelist           = getlanguagelist();
  
  return (
    
    <div className="gallery_section" id="section1">
    {albumList.map((tile,index) => {
       let rowitem = parseInt(index + 1)
        return (
        <div className={((rowitem%3 == 0) && (rowitem > 1))? 'row' : ''}  key={`album${index}`}>
     
        <div className="col-lg-4">
          
            <div className="album_box uxhover hoverEffect-tenth">
                <img className="aldum_cover" 
                      src={(tile.media_type == 'VIDEO') ? tile.thumbnail : tile.media_link} alt={tile.album_name} 
                      onError = {(e) => {
                        e.target.src = iconPath['BREAKIMAGE']
                      }} 
                />
                <div className="mask">
                <div className="album_con">
                    <a className="option_icon" href={void(0)} id={`togglebtn${tile.albumid}`} onClick={()=>toggleFunction(tile.albumid)}><i className="fas fa-ellipsis-v"></i></a>
                    
                    <ul className="post_menu_list album_action" id={`togglediv${tile.albumid}`}>
                        {
                          (props.ownProfile == true) ? 
                            <li><Link to={`/album_edit/${encrypt(tile.albumid)}`}>{languagelist.edit} </Link></li>
                          : null
                        }
                        {
                          (props.ownProfile == true) ? 
                           <li><a href={void(0)} onClick={()=>deleteAlbum(tile.albumid,tile.feed_id,'ALBUM')}>{languagelist.delete}</a></li>
                          : null
                         
                        } 
                        <li><Link to={`/album/${encrypt(tile.albumid)}`}>{languagelist.details} </Link></li>
                    </ul>

                    <h2> <Link  style={{color:'white'}}  to={`/album/${encrypt(tile.albumid)}`}>{tile.album_name}</Link></h2>
                    <p>{tile.created_at}</p>
                </div>
                <div className="like_commend_section">
                  <Link to={`/album/${encrypt(tile.albumid)}`}>
                    <ul className="pull-left">
                      <li>
                        {(tile.my_reaction!= '') ?
                           <img style={{width:'28px'}} src={iconPath[tile.my_reaction]} /> 
                          : <img style={{width:'33px'}} src='/assets/images/like_dislike_goldspace.png' /> 
                        }
                         &nbsp; {tile.total_reaction}
                      </li>
                    </ul>
                    <ul className="pull-right" style={{float: 'right'}}>
                      <li>
                        <img src={iconPath['ALBUMCOMMENT']} /> {tile.total_comment}
                      </li>
                      <li>|</li>
                      <li className="checkApp">
                        <img src={iconPath['ALBUMSHARE']} /> {tile.total_share}
                      </li>
                    </ul>
                  </Link>
                </div>
                </div>
               
                  
                
            </div>
            
        </div>
      </div>
      )
    })
  }

       {/*  <div className="text-center">
            <div className="clr20"></div> <a href="#" className="load_btn">Load More...</a>
            <div className="clr20"></div>
        </div> */}
       {/*  <a href="#" className="add_image_icon"><img src={iconPath['LARGEADD']} /></a> */}
       {
         (props.ownProfile == true) ? 
          <CreateAlbum />
         : null
       }
       
    </div>
  

  );
}
